import { render, staticRenderFns } from "./bank-account-fix-modal.vue?vue&type=template&id=255446e1&scoped=true&"
import script from "./bank-account-fix-modal.vue?vue&type=script&lang=js&"
export * from "./bank-account-fix-modal.vue?vue&type=script&lang=js&"
import style0 from "./bank-account-fix-modal.vue?vue&type=style&index=0&id=255446e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255446e1",
  null
  
)

export default component.exports